<template>
  <router-view/>
</template>
<script>
    export default {
    name: 'respuestasIndex'
    }
</script>

<style scoped>

</style>
